import {
  CASE_STATE_LABELS,
  CASE_STATUS_LABELS,
  type Case,
  type CaseStatus,
} from '../../types/case'
import { cn } from '../../lib/utils'

const STATUS_BADGE_STYLES: Record<CaseStatus, string> = {
  draft: 'bg-parch-100 text-ink-600',
  published: 'bg-info-lt text-info',
  scheduled: 'bg-gold-lt text-gold',
}

const STATE_BADGE_STYLES: Record<'under_review' | 'review_closed' | 'archived', string> = {
  under_review: 'bg-green-200 text-green-800',
  review_closed: 'bg-green-100 text-green-700',
  archived: 'bg-danger-lt text-danger',
}

export function CaseStatusBadge({
  status,
  className,
}: {
  status: Case['status']
  className?: string
}) {
  if (!status) {
    return <span className="text-ink-400">—</span>
  }

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold',
        STATUS_BADGE_STYLES[status],
        className,
      )}
    >
      {CASE_STATUS_LABELS[status]}
    </span>
  )
}

export function CaseStateBadge({
  state,
  className,
}: {
  state: 'under_review' | 'review_closed' | 'archived'
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold',
        STATE_BADGE_STYLES[state],
        className,
      )}
    >
      {CASE_STATE_LABELS[state]}
    </span>
  )
}

/** Status + workflow state pills (list/detail). */
export function CaseStatusStateBadges({ caseItem }: { caseItem: Case }) {
  return (
    <div className="flex flex-wrap gap-1">
      {caseItem.status ? <CaseStatusBadge status={caseItem.status} /> : null}
      {caseItem.is_under_review ? <CaseStateBadge state="under_review" /> : null}
      {!caseItem.is_under_review && caseItem.is_review_closed ? (
        <CaseStateBadge state="review_closed" />
      ) : null}
      {caseItem.is_archived ? <CaseStateBadge state="archived" /> : null}
    </div>
  )
}
